// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___v9XO9","invisible":"style__invisible___Fb5X0","overlay":"style__overlay___1vZEy","active":"style__active___3UDPF"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/overlay/style.scss
 ** module id = 377
 ** module chunks = 0
 **/